<template>
  <div>
    <SignaturePad
      :showSignaturePad="showSignaturePad"
      @close="showSignaturePad = false"
      @signatureData="signatureData"
    />
    <v-card min-height="40vh">
      <v-col
        cols="12"
        class="white--text text-uppercase text-center text-caption"
        style="background-color: #2b3990; "
        >{{ title }}
      </v-col>
      <v-col cols="12" md="12">
        <p class="text-caption">
         The DHS/DCFS/DSPD contract contains important information pertaining to my responsibilities
         at {{ userCompany }}. I understand that I should consult my direct supervisor, the Human Resources
         Department, and /or the Executive Council if I have any questions about the information contained
         in the contract.
        </p>
        <p class="text-caption">
          Since the information described in the contract is subject to charge, I acknowledge that revisions
          to the contract may occur.
        </p>
        <p class="text-caption">
          I acknowledge that I have been given access to and understand the contract. I understand that it is
          my responsibility to continually understand and comply with the policies contained in the contract
          and any revisions made to it.
        </p>
        <p class="text-caption">
          I am aware that a copy of the contract has been made available to me for future reference. I have been
          given the opportunity to ask any questions regarding the contract.
        </p>
        <p class="text-caption">
          I agree to conduct my activities in accordance with {{ userCompany }} as outlined in the contract and
          understand that breaching these standards may result in disciplinary action up to and including termination
          or other legal remediation available to the organization.
        </p>
      </v-col>
      <v-col cols="12" md="12">
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="item.employeeName"
              label="Employee Name (print)"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <div style="position: relative">
              <v-text-field
                label="Employee's Signature"
                @click.stop="updateSignature('employee')"
              ></v-text-field>
              <v-img
                width="150"
                height="50"
                :src="employeeSignatureForContractUnderstanding"
                style="position:absolute;top:10px;right:150px;"
              ></v-img>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <v-menu
              ref="menu"
              v-model="dateMenuForEmployee"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateSignedEmployeeForContractUnderstanding"
                  label="Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                no-title
                v-model="dateSignedEmployeeForContractUnderstanding"
                @input="dateMenuForEmployee = false"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-col cols="12" md="12">
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="supervisorNameForContractUnderstanding"
              label="Supervisor Name (print)"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <div style="position: relative">
              <v-text-field
                label="Supervisor's Signature"
                @click.stop="updateSignature('supervisor')"
              ></v-text-field>
              <v-img
                width="150"
                height="50"
                :src="supervisorSignatureForContractUnderstanding"
                style="position:absolute;top:10px;right:150px;"
              ></v-img>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <v-menu
              ref="menu"
              v-model="dateMenuForSupervisor"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateSignedSupervisorForContractUnderstading"
                  label="Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                no-title
                v-model="dateSignedSupervisorForContractUnderstading"
                @input="dateMenuForSupervisor = false"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        </v-col>
        <v-row>
          <v-col>
            <v-row align="center" justify="start">
              <v-card-actions>
                <v-btn @click="prev">Prev</v-btn>
              </v-card-actions>
            </v-row>
          </v-col>
          <v-col>
            <v-row align="center" justify="end">
              <v-card-actions>
                <v-btn @click="next">Next</v-btn>
              </v-card-actions>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-card>
  </div>
</template>
<script>
/* eslint-disable */
import SignaturePad from "@/components/SignaturePad";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import download from "downloadjs";

export default {
  components: { SignaturePad },
  props: {
    title: {
      type: String,
      default: "",
    },
    user: {
      type: Object,
    },
    currentStep: {
      type: Number,
    },
  },
  data: function() {
    return {
      dateMenuForEmployee: false,
      dateMenuForSupervisor : false,
      employeeSignatureForContractUnderstanding: "",
      showSignaturePad: false,
      item: {},
      step: this.currentStep,
      supervisorNameForContractUnderstanding: "",
      supervisorSignatureForContractUnderstanding: "",
    };
  },

  created() {
    this.populateUserInfo();
    const savedEmployeeSignature = localStorage.getItem("employeeSignatureForContractUnderstanding");
      const savedSupervisorSignature = localStorage.getItem("supervisorSignatureForContractUnderstanding");

    if (savedEmployeeSignature) {
      this.employeeSignatureForContractUnderstanding = savedEmployeeSignature;
    }

    if (savedSupervisorSignature) {
      this.supervisorSignatureForContractUnderstanding = savedSupervisorSignature;
    }
  },

  computed: {
    ...mapGetters("userDocuments", ["getUserDocuments"]),
    ...mapGetters("users", {
      user: "user",
      userCompany: "userCompany",
    }),
  },

  methods: {
    ...mapActions({
      getDocuments: "userDocuments/getDocuments",
      addTransportationDoc: "userDocuments/saveTransportationDocument",
      addDocument: "userDocuments/updateDocument",
      downloadDocuments: "userDocuments/downloadDocuments",
    }),

    updateSignature(signer) {
        this.currentSigner = signer; // Store which signer's signature is being updated
        this.showSignaturePad = true;
    },

    signatureData(data) {
        if (this.currentSigner === 'employee') {
            this.employeeSignatureForContractUnderstanding = data;
            localStorage.setItem("employeeSignatureForContractUnderstanding", data);
        } else if (this.currentSigner === 'supervisor') {
            this.supervisorSignatureForContractUnderstanding = data;
            localStorage.setItem("supervisorSignatureForContractUnderstanding", data);
        }
    },

    next() {
      this.addItem();
      // this.generatePDF();
      this.$emit("clicked", this.step + 1);
    },
     prev() {
      this.$emit("clicked", this.step - 1);
    },

    async addItem() {
      try {
        const response = await this.addDocument({
          data: { ...this.item, Employee: this.user._id },
          pdfDocument: "client-transportation-agreement",
        });
        console.log(response);
        localStorage.setItem('supervisorNameForContractUnderstanding', this.supervisorNameForContractUnderstanding);
        localStorage.setItem('dateSignedEmployeeForContractUnderstanding', this.dateSignedEmployeeForContractUnderstanding);
        localStorage.setItem('dateSignedSupervisorForContractUnderstading', this.dateSignedSupervisorForContractUnderstading);
      } catch (error) {
        console.log(error);
      }
    },

    async populateUserInfo() {
      const dateSignedForEmployee = localStorage.getItem('dateSignedEmployeeForContractUnderstanding');
      const dateSignedForSupervisor = localStorage.getItem('dateSignedSupervisorForContractUnderstading');
      const supervisor = localStorage.getItem('supervisorNameForContractUnderstanding');

      if (dateSignedForEmployee !== null) {
         this.dateSignedEmployeeForContractUnderstanding= dateSignedForEmployee;
      }

      if (dateSignedForSupervisor !== null) {
         this.dateSignedSupervisorForContractUnderstading= dateSignedForSupervisor;
      }

      if (supervisor !== null) {
         this.supervisorNameForContractUnderstanding= supervisor;
      }



      this.item.employeeName = this.user.Name;

      const response = await this.getDocuments(this.user._id);
      let documents = this.updateCase(
        response.data.document.Documents.ClientTransportationAgreement
      );

      this.item = Object.assign(
        {},
        {
          ...documents,
          employeeName: response.data.document.Employee.Name,
        }
      );
    },

    async generatePDF() {
      const response = await this.downloadDocuments({
        id: this.user._id,
        pdfDocument: "client-transportation-agreement",
      });
      let pdfFile =
        "data:application/octet-stream;base64," + response.data.data;
      download(
        pdfFile,
        "client-transportation-agreement.pdf",
        "application/pdf"
      );
    },

    updateCase(obj) {
      let output = Object.entries(obj).map(([key, value]) => [
        key[0].toLowerCase() + key.slice(1),
        value,
      ]);
      return Object.fromEntries(output);
    },
  },
};
</script>
<style scoped>
.theme--light.v-btn.v-btn--has-bg {
  background-color: #2b3990;
  color: #fff;
  border-radius: 1.25rem;
}
</style>
